import {Category} from './Category';

export class Question {
    id: number;
    category: Category;
    question: string;
    answer: string;

    constructor(id: number, category: Category, question: string, answer: string) {
        this.id = id;
        this.category = category;
        this.question = question;
        this.answer = answer;
    }
}
